import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from 'app/src/app/core/app.service';
import { LibService } from 'lib/src/public-api';

import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy{
  isConnected = true;
  noInternetConnection: boolean;
  title = 'Cliente';
  @HostBinding('class') themeColor: any;
  private destroyed = new Subject();

  constructor(
    private overlayContainer: OverlayContainer,
    private appService: AppService,
    private translate: TranslateService,
    private libService: LibService,
  ) {
    this.translate.setDefaultLang('es');
    this.translate.use('es');
  }

  ngOnInit(){
    this.changeThemeColor();
    // this.authService.initAuth();

    // this.userService.user$
    // .pipe(
    //   takeUntil(this.destroyed),
    //   filter(user => !!user?.company))
    // .subscribe(user=>{
    //   //this.libService.company = user.company;
    // })
  }

  changeThemeColor() {
    const overlay = this.overlayContainer.getContainerElement();
    this.appService.isLightTheme$.pipe(takeUntil(this.destroyed), distinctUntilChanged()).subscribe(isLightTheme => {
      const prevTheme = this.themeColor;
      this.themeColor = isLightTheme ? 'theme-light' : 'theme-dark';
      overlay.classList.remove(prevTheme)
      overlay.classList.add(this.themeColor)
    });
  }

  ngOnDestroy(): void {
    this.destroyed.next(null);
    this.destroyed.complete();
  }

}
